export const UNIQUE_CONFIG_KEY = 'frontend-chats';
